export function OutlineRefresh1Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0178 12.9984C20.0178 17.4192 16.437 21 12.0162 21C7.59545 21 4.01465 17.4192 4.01465 12.9984C4.01465 8.5776 7.60025 5.0016 12.0162 5.0016C12.3522 5.0016 12.6882 5.0208 13.0146 5.064V3L16.1922 6.1728L17.0178 6.9984L14.709 9.3072L13.0146 11.0016V8.5392C12.693 8.4672 12.357 8.4288 12.0162 8.4288C9.49145 8.4288 7.44665 10.4736 7.44665 12.9984C7.44665 15.5232 9.49145 17.5728 12.0162 17.5728C14.541 17.5728 16.5858 15.5232 16.5858 12.9984H20.0178Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
